let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    // {
    //     label: '运营商名称',
    //     props: 'dealName',
    //     minWidth: 200,
    // },
    {
        label: '电站ID',
        props: 'stationNo',
        minWidth: 200,
    },
    {
        label: '电站名称',
        props: 'stationName',
        minWidth: 180,
        tooltip: true,
    },
    {
        label: '电站地址',
        props: 'stationAddr',
        minWidth: 180,
        tooltip: true,
    },
    {
        label: '区域',
        props: 'province',
        minWidth: 300,
        formatter: function formatter(row, column, cellValue, index) {
            if(row.province){
                if(row.city){
                    if(row.county){
                        return row.province+'-'+row.city+'-'+row.county;
                    }else{
                        return row.province+'-'+row.city;
                    }
                }else{
                    return row.province;
                }
            }else{
                return '';
            }

        }
    },
    {
        label: '充电枪数量',
        props: 'totalPileCount',
        minWidth: 200,
    },
    {
        label: '异常桩数量',
        props: 'errorPileCount',
        minWidth: 200,
    },
    {
        label: '充电量',
        props: 'totalChargeCount',
        minWidth: 180,
    },
    {
        label: '资费（元）',
        props: 'ttlVal',
        minWidth: 120,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.ttlVal) {
                return row.ttlVal
            }
            else {
                return '0'
            }
        }
    },
    {
        label: '运营状态',
        props: 'stationStatusName',
        minWidth: 200,
    },
];

// // 面包屑
pageConfig.listBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '充电管理'
    },
    {
        type: 'title',
        name: '电站列表'
    }
];

// 详情的面包屑
pageConfig.detailBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '充电管理',
    },
    {
        type: 'router',
        name: '电站管理',
        router: 'pileStationList'
    },
    {
        type: 'title',
        name: '电站详情',
    }
];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: true,
    showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}

pageConfig.dialogPagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}
// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'id',
    editRouter: 'pileStationDetail',
};

// 路由
pageConfig.listRouter = 'pileStationList';

//详情
pageConfig.reportDetailRouter = 'reportDetail';

pageConfig.postageDetailRouter = 'postageDetail';

pageConfig.pileListRouter = 'pileList';

pageConfig.orderListRouter = 'orderManageList';

pageConfig.tariffDetailRouter = 'tariffDetail';

pageConfig.replenishmentDetailRouter = 'replenishmentDetail';

pageConfig.feedforwardDetailRouter = 'feedforwardDetail';

pageConfig.formRules = {
    stationName: [{ required: true, message: '请输入电站名称', trigger: 'blur' }],
    stationAddr: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
    parkRate: [{ required: true, message: '请选择停车费', trigger: 'change' }],
    stationDesc: [{ required: true, message: '请输入站点说明', trigger: 'blur' }],
    ttlVal: [{ required: true, message: '请输入资费', trigger: 'blur' }],
    fixedVal: [{ required: true, message: '请输入基本电费', trigger: 'blur' }],
    stationStatus: [{ required: true, message: '请选择运营状态', trigger: 'blur' }],
};

export default pageConfig;
